import 'src/styles/ui/switch.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Switch — pill toggle control (on/off filter toggles, settings).
 *
 * @example
 * <Switch id='show-cancelled' label='Cancelled' checked={show} onChange={() => setShow(s => !s)} />
 */
const Switch = ({ id, label, checked, onChange, disabled }) => (
  <label htmlFor={id} className={classNames('switch', { 'switch--disabled': disabled })}>
    <input
      id={id}
      type='checkbox'
      role='switch'
      className='switch__input'
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    <span className='switch__track' />
    {label}
  </label>
);

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Switch.defaultProps = {
  label: '',
  checked: false,
  onChange: () => {},
  disabled: false,
};

export default Switch;
